import { useState } from "react";
import "./Slider.scss"

const Slider = (props: any) => {

    const { data, onSelect, Component } = props;
    const [selectedItemId, setSelectedItemId] = useState(null);

    const handleSelect = (item: any) => {
        setSelectedItemId(item.id)
        onSelect(item);
    }

    return (<div className="slider_row">
        {data?.map((item: any) => <div key={`machine_card_${item.id}`} onClick={() => { handleSelect(item) }} ><Component data={item} selected={selectedItemId === item.id} /></div>)}
    </div>);
}

export default Slider;